/**
 * @generated SignedSource<<8e6e6637c515e0072955e09946989345>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentNotificationEmailCtaButton = "disabled" | "enabled" | "%future added value";
export type ContentSystemTaskKind = "add_events_to_calendar" | "calendar_connection" | "community_agreement" | "complete_profile" | "connect_slack" | "custom_profile_field" | "default_profile_fields" | "download_mobile_app" | "onboarding_complete" | "onboarding_module" | "onboarding_welcome" | "slack_connection" | "slack_invite" | "%future added value";
export type EventVisibility = "cohort" | "member_group" | "public" | "%future added value";
export type OccurrenceMediaKind = "image" | "video" | "%future added value";
export type OccurrenceReminderAudience = "all" | "non_rsvps" | "rsvps" | "%future added value";
export type OccurrenceStatus = "draft" | "published" | "%future added value";
export type ProductStatus = "archived" | "draft" | "published" | "unlisted" | "%future added value";
export type ProductType = "community_event" | "course" | "membership_plan" | "pathway" | "%future added value";
export type WebFormQuestionType = "link" | "multiple_select" | "ranking" | "rating" | "single_select" | "written_answer" | "%future added value";
export type CreateEventInput = {
  addMemberGroupIds?: ReadonlyArray<string> | null;
  allowGuestAccess?: boolean | null;
  appId?: string | null;
  capacity?: number | null;
  collectFeedback?: boolean | null;
  content?: CreateContentInput | null;
  datetimeRange: ReadonlyArray<string>;
  guestCapacity?: number | null;
  hosts?: ReadonlyArray<OccurrenceHostInput> | null;
  meetingProviderId?: string | null;
  meetingUrl?: string | null;
  notificationEmailBody?: string | null;
  organizationId?: string | null;
  physicalAddress?: GoogleMapAddressComponents | null;
  productId?: string | null;
  reminders?: ReadonlyArray<OccurrenceReminderInput> | null;
  rrule?: string | null;
  status?: OccurrenceStatus | null;
  timezone?: string | null;
  videoRoomType: string;
  visibility: EventVisibility;
};
export type GoogleMapAddressComponents = {
  address: string;
  displayAddress?: string | null;
  image?: string | null;
  lat: number;
  lng: number;
  name?: string | null;
  placeId: string;
};
export type CreateContentInput = {
  attachments?: ReadonlyArray<ContentAttachmentInput> | null;
  contentLabelId?: string | null;
  coverAudio?: string | null;
  coverPhoto?: string | null;
  coverPhotoAssetId?: string | null;
  coverVideo?: string | null;
  coverVideoAssetId?: string | null;
  coverVideoDurationSeconds?: number | null;
  createdById?: string | null;
  description?: string | null;
  id?: string | null;
  isAiGenerated?: boolean | null;
  name?: string | null;
  notificationEmailCtaButton?: ContentNotificationEmailCtaButton | null;
  notificationEmailSubject?: string | null;
  releaseDatetime?: string | null;
  richEditorDescriptionContent?: string | null;
  richEditorNotificationEmailBodyContent?: string | null;
  sendNotificationEmail?: boolean | null;
  showComments?: boolean | null;
  showCoverPlayIcon?: boolean | null;
  submissionLink?: string | null;
  systemTaskKind?: ContentSystemTaskKind | null;
  thumbnailAssetId?: string | null;
  thumbnailUrl?: string | null;
  webFormRevision?: CreateWebFormRevisionInput | null;
};
export type ContentAttachmentInput = {
  id?: string | null;
  mediaAssetId?: string | null;
  mediaUrl?: string | null;
  name?: string | null;
};
export type CreateWebFormRevisionInput = {
  contentUsageId?: string | null;
  questions: ReadonlyArray<WebFormQuestionInput>;
  webFormId: string;
};
export type WebFormQuestionInput = {
  answerKey?: WebFormQuestionAnswerKeyInput | null;
  isRequired?: boolean | null;
  options?: ReadonlyArray<WebFormQuestionOptionInput> | null;
  richEditorBody: string;
  type: WebFormQuestionType;
};
export type WebFormQuestionOptionInput = {
  id: string;
  label: string;
};
export type WebFormQuestionAnswerKeyInput = {
  correctIds: ReadonlyArray<string>;
  feedback?: string | null;
};
export type OccurrenceHostInput = {
  organizationMembershipId?: string | null;
  productMembershipId?: string | null;
};
export type OccurrenceReminderInput = {
  audience: OccurrenceReminderAudience;
  emailRichEditorBody: string;
  emailSubject: string;
  id?: string | null;
  timing: string;
};
export type CreateEventFormMutation$variables = {
  input: CreateEventInput;
};
export type CreateEventFormMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly appId: string | null;
      readonly content: {
        readonly hasViewerBookmarked: boolean;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"BookmarkButtonContentFragment">;
      };
      readonly coverPhoto: string | null;
      readonly datetimeRange: ReadonlyArray<string>;
      readonly event: {
        readonly id: string;
        readonly isRecurring: boolean;
        readonly memberGroups: {
          readonly totalCount: number;
        };
        readonly productId: string;
        readonly " $fragmentSpreads": FragmentRefs<"MemberGroupEventTagListFragment" | "usePermissionsFragment">;
      };
      readonly guestReport: {
        readonly totalCount: number;
      };
      readonly hosts: {
        readonly totalCount: number;
      };
      readonly id: string;
      readonly isComplete: boolean;
      readonly media: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly kind: OccurrenceMediaKind;
            readonly url: string;
          };
        }>;
      } | null;
      readonly name: string | null;
      readonly product: {
        readonly cover: string;
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly status: ProductStatus;
        readonly type: ProductType;
      };
      readonly rsvps: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly user: {
              readonly fullName: string;
            };
          };
        }>;
        readonly totalCount: number;
      } | null;
      readonly status: OccurrenceStatus;
      readonly visibility: EventVisibility;
      readonly " $fragmentSpreads": FragmentRefs<"DeleteOccurrenceButtonFragment" | "OccurrenceNameAndTimeFragment" | "OccurrenceRSVPAttendanceStatusFragment" | "OccurrenceStatusChipFragment" | "OccurrenceWatchVideoButtonFragment">;
    } | null;
  };
};
export type CreateEventFormMutation = {
  response: CreateEventFormMutation$data;
  variables: CreateEventFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "datetimeRange",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRecurring",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverPhoto",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplete",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "OccurrenceHostNodeConnection",
  "kind": "LinkedField",
  "name": "hosts",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cover",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasViewerBookmarked",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "UserMembershipNodeConnection",
  "kind": "LinkedField",
  "name": "guestReport",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v20 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "OccurrenceMediaNodeConnection",
  "kind": "LinkedField",
  "name": "media",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OccurrenceMediaNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OccurrenceMedia",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            (v22/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "media(first:1)"
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v26 = [
  (v25/*: any*/)
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v28 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v25/*: any*/),
  (v27/*: any*/)
],
v29 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v25/*: any*/),
  (v27/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateEventFormMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "CreateEventResponse",
        "kind": "LinkedField",
        "name": "createEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Occurrence",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MemberGroupEventTagListFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "usePermissionsFragment"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroupNodeConnection",
                    "kind": "LinkedField",
                    "name": "memberGroups",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v8/*: any*/),
                  (v17/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v18/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BookmarkButtonContentFragment"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OccurrenceNameAndTimeFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OccurrenceRSVPAttendanceStatusFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OccurrenceStatusChipFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OccurrenceWatchVideoButtonFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DeleteOccurrenceButtonFragment"
              },
              (v19/*: any*/),
              {
                "alias": null,
                "args": (v20/*: any*/),
                "concreteType": "OccurrenceRSVPNodeConnection",
                "kind": "LinkedField",
                "name": "rsvps",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OccurrenceRSVPNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OccurrenceRSVP",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "rsvps(first:3)"
              },
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          (v24/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateEventFormMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "CreateEventResponse",
        "kind": "LinkedField",
        "name": "createEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Occurrence",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberGroupNodeConnection",
                    "kind": "LinkedField",
                    "name": "memberGroups",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberGroupNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberGroup",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "parentMemberGroupId",
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "color",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "role",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isSystem",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v26/*: any*/),
                        "type": "Organization",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "nonNullProductId",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          (v25/*: any*/),
                          (v27/*: any*/)
                        ],
                        "type": "Product",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v28/*: any*/),
                        "type": "Event",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v29/*: any*/),
                        "type": "Comment",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v29/*: any*/),
                        "type": "Feed",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v29/*: any*/),
                        "type": "Post",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": "nullableProductIdString",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "productId",
                            "storageKey": null
                          },
                          (v25/*: any*/),
                          (v27/*: any*/)
                        ],
                        "type": "ContentUsage",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v29/*: any*/),
                        "type": "ChatChannel",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v29/*: any*/),
                        "type": "Dashboard",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v28/*: any*/),
                        "type": "AssignmentSubmission",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v26/*: any*/),
                        "type": "PathwayGroup",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v26/*: any*/),
                        "type": "BrainSearch",
                        "abstractKey": null
                      }
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "product",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v8/*: any*/),
                  (v17/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductMembership",
                    "kind": "LinkedField",
                    "name": "viewerMembership",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasViewerRSVPd",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "capacity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "atCapacity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timezone",
                "storageKey": null
              },
              (v23/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": (v20/*: any*/),
                "concreteType": "OccurrenceRSVPNodeConnection",
                "kind": "LinkedField",
                "name": "rsvps",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OccurrenceRSVPNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OccurrenceRSVP",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "rsvps(first:3)"
              }
            ],
            "storageKey": null
          },
          (v24/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "94dc19e27c07869c37266663ad067b3e",
    "id": null,
    "metadata": {},
    "name": "CreateEventFormMutation",
    "operationKind": "mutation",
    "text": "mutation CreateEventFormMutation(\n  $input: CreateEventInput!\n) {\n  response: createEvent(input: $input) {\n    node {\n      id\n      datetimeRange\n      event {\n        productId\n        isRecurring\n        id\n        ...MemberGroupEventTagListFragment\n        ...usePermissionsFragment\n        memberGroups {\n          totalCount\n        }\n      }\n      name\n      coverPhoto\n      status\n      isComplete\n      visibility\n      appId\n      hosts {\n        totalCount\n      }\n      product {\n        id\n        cover\n        type\n        name\n        slug\n        status\n      }\n      content {\n        id\n        hasViewerBookmarked\n        ...BookmarkButtonContentFragment\n      }\n      ...OccurrenceNameAndTimeFragment\n      ...OccurrenceRSVPAttendanceStatusFragment\n      ...OccurrenceStatusChipFragment\n      ...OccurrenceWatchVideoButtonFragment\n      ...DeleteOccurrenceButtonFragment\n      guestReport {\n        totalCount\n      }\n      rsvps(first: 3) {\n        totalCount\n        edges {\n          node {\n            id\n            user {\n              fullName\n              id\n            }\n          }\n        }\n      }\n      media(first: 1) {\n        edges {\n          node {\n            id\n            url\n            kind\n          }\n        }\n      }\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment BookmarkButtonContentFragment on Content {\n  id\n  hasViewerBookmarked\n}\n\nfragment DeleteOccurrenceButtonFragment on Occurrence {\n  id\n}\n\nfragment MemberGroupEventTagListFragment on Event {\n  id\n  product {\n    type\n    id\n  }\n  memberGroups {\n    edges {\n      node {\n        id\n        kind\n        parentMemberGroupId\n        name\n        product {\n          name\n          id\n        }\n        ...MemberGroupTagFragment\n      }\n    }\n  }\n}\n\nfragment MemberGroupTagFragment on MemberGroup {\n  id\n  name\n  kind\n  color\n  role\n  isSystem\n  product {\n    id\n    name\n  }\n}\n\nfragment OccurrenceAttendingButtonFragment on Occurrence {\n  id\n  product {\n    id\n    slug\n    type\n  }\n}\n\nfragment OccurrenceNameAndTimeFragment on Occurrence {\n  id\n  name\n  datetimeRange\n  event {\n    isRecurring\n    id\n  }\n}\n\nfragment OccurrenceRSVPAttendanceStatusFragment on Occurrence {\n  id\n  product {\n    id\n    slug\n    type\n  }\n  ...RSVPToEventButtonFragment\n  ...occurrenceUtils_useOccurrenceStatusFragment\n  ...OccurrenceRegisterAndRSVPButtonFragment\n  ...OccurrenceAttendingButtonFragment\n}\n\nfragment OccurrenceRegisterAndRSVPButtonFragment on Occurrence {\n  id\n  product {\n    id\n    slug\n    type\n  }\n}\n\nfragment OccurrenceStatusChipFragment on Occurrence {\n  id\n  datetimeRange\n  ...occurrenceUtils_useOccurrenceStatusFragment\n}\n\nfragment OccurrenceWatchVideoButtonFragment on Occurrence {\n  id\n  ...occurrenceUtils_useOccurrenceStatusFragment\n}\n\nfragment RSVPToEventButtonFragment on Occurrence {\n  id\n  status\n  hasViewerRSVPd\n  capacity\n  atCapacity\n  event {\n    id\n    isRecurring\n  }\n}\n\nfragment occurrenceUtils_useOccurrenceStatusFragment on Occurrence {\n  id\n  datetimeRange\n  hasViewerRSVPd\n  timezone\n  product {\n    viewerMembership {\n      id\n    }\n    id\n  }\n  media(first: 1) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  event {\n    ...usePermissionsFragment\n    id\n  }\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "79adeb69da7d315761827fa5d8077b5c";

export default node;
